<template>
  <header v-if="storeName.FR" class="fr-head" ref="headNode">
    <div>
      <a :href="logoHomeLink.fr" target="_blank">
        <img class="main-logo" src="@/assets/img/FR/logo.png" alt="logo" />
      </a>
      <MainNav
        @resetH="resetIfrH"
        :isMob="isMob"
        :navItems="frNav.navItems"
        :search="frNav.search"
      />
    </div>
    <Slide
      v-if="fr_swiperMain.isShow"
      :banners="fr_swiperMain.banners"
      :swiperOption="fr_swiperMain.swiperOption"
      :swiperName="fr_swiperMain.name"
      :navigation="fr_swiperMain.swiperOption.navigation"
    />
  </header>

  <header v-else-if="storeName.DE_s" class="de-s-head" ref="headNode">
    <div>
      <a :href="logoHomeLink.de_s" class="logoImg-wrap" target="_blank">
        <img
          class="main-logo"
          src="@/assets/img/DE_s/de_small_logo.png"
          alt="logo"
        />
      </a>
      <MainNav
        @resetH="resetIfrH"
        :isMob="isMob"
        :navItems="de_sNav.navItems"
        :search="de_sNav.search"
      />
      <Slide
        v-if="de_s_MainSwiper.isShow"
        :banners="de_s_MainSwiper.banners"
        :swiperOption="de_s_MainSwiper.swiperOption"
        :swiperName="de_s_MainSwiper.name"
        :navigation="de_s_MainSwiper.swiperOption.navigation"
      >
        <template #bg>
          <div class="swiper-pagination-bg"></div>
        </template>
      </Slide>
    </div>
  </header>

  <header v-else-if="storeName.EE" class="ee-head" ref="headNode">
    <MainNav
      @resetH="resetIfrH"
      :isMob="isMob"
      :navItems="eeNav.navItems"
      :search="eeNav.search"
    />
    <Video
      :video="eeVideo.videoType"
      :autoplay="eeVideo.autoplay"
      :loop="eeVideo.loop"
      :muted="eeVideo.muted"
      :logoUrl="eeVideo.storeLogo"
    ></Video>
  </header>
</template>

<script>
import Slide from "../small/Slide";
import MainNav from "../small/MainNav";
import Video from "../small/Video";
import { mapState } from "vuex";

export default {
  name: "header-section",
  data() {
    return {
      isMob: null,
      logoHomeLink: {
        fr: "https://www.ebaystores.fr/sunnyshowersfrance",
        de_s: "xxxx",
      },
      fr_swiperMain: {
        name: "fr-Banner",
        isShow: true,
        banners: [
          {
            id: 1,
            url: require("@/assets/img/FR/banner_01.jpg"),
            link: "https://www.ebay.fr/itm/233500835253",
            description: {
              title: null,
              paragraph: null,
              btnName: null,
              btnLink: null,
            },
          },
          {
            id: 2,
            url: require("@/assets/img/FR/banner_02.jpg"),
            link: "https://www.ebay.fr/itm/233002685217",
          },
          {
            id: 3,
            url: require("@/assets/img/FR/banner_03.jpg"),
            link: "https://www.ebay.fr/itm/233500817127",
          },
        ],
        swiperOption: {
          speed: 500,
          loop: true,
          autoplay: {
            delay: 2000,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        },
      },
      de_s_MainSwiper: {
        name: "de-s-banner",
        isShow: true,
        banners: [
          {
            id: 1,
            url: require("@/assets/img/DE_s/big_banner1.png"),
            description: {
              title: "Artikelbeschreigung",
              paragraph: `<p>Große :120x90 cm</p>
          <p>Reversible Konstruktion：Anschlag rechts und links möglich</p>
          <p>Einscheiben-Sicherheitsglas (ESG) 5mm nach EN 12150</p>
          <p>Hochwertiger Aluminium-Rahmen (matt verchromt)</p>
          <p>Stangengriff aus verchromtem Edelstahl</p>`,
              btnName: "$345.99",
              btnLink: "xxxxxxxxxx",
            },
            link: "#",
          },
          {
            id: 2,
            url: require("@/assets/img/DE_s/big_banner1.png"),
            description: {
              title: "finden sie ihres gewünschte produkt hier",
            },
            link: "#",
          },
        ],
        swiperOption: {
          speed: 1000,
          loop: true,
          autoplay: {
            delay: 2000,
          },
          effect: "coverflow",
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
        },
      },
      // FR-Nav===========================================
      frNav: {
        navItems: [
          {
            id: 1,
            name: "page d’accueil",
            link: "https://www.ebaystores.fr/sunnyshowersfrance",
            isActive: false,
          },
          {
            id: 2,
            name: "cabine de douche",
            link:
              "https://www.ebaystores.fr/sunnyshowersfrance/Porte-de-douche-/_i.html?_fsub=30097606014&_sid=1857768744&_trksid=p4634.c0.m322",
            isActive: false,
          },
          {
            id: 3,
            name: "receveur de douche",
            link:
              "https://www.ebaystores.fr/sunnyshowersfrance/Receveur-de-douche-/_i.html?_fsub=30097605014&_sid=1857768744&_trksid=p4634.c0.m322",
            isActive: false,
          },
          {
            id: 4,
            name: "miroir led",
            link:
              "https://www.ebaystores.fr/sunnyshowersfrance/Miroir-de-salle-de-bain-/_i.html?_fsub=26925887014&_sid=1857768744&_trksid=p4634.c0.m322",
            isActive: false,
          },
          {
            id: 5,
            name: "radiateur",
            link:
              "https://www.ebaystores.fr/sunnyshowersfrance/Radiateur-a-eau-/_i.html?_fsub=30097602014&_sid=1857768744&_trksid=p4634.c0.m322",
            isActive: false,
          },
          {
            id: 6,
            name: "colonne de douche",
            link:
              "https://www.ebaystores.fr/sunnyshowersfrance/Cabine-de-douche-/_i.html?_fsub=30097607014&_sid=1857768744&_trksid=p4634.c0.m322",
            isActive: false,
          },
          {
            id: 7,
            name: "accessoires",
            link:
              "https://www.ebaystores.fr/sunnyshowersfrance/Accessoire-/_i.html?_fsub=30097604014&_sid=1857768744&_trksid=p4634.c0.m322",
            isActive: false,
          },
        ],
        search: {
          isShow: true,
          form: {
            className: "form-inline",
            action: "http://www.ebaystores.fr/sunnyshowersfrance",
            placeholder: "Search...",
          },
        },
      },
      // DE-s-Nav===========================================
      de_sNav: {
        navItems: [
          {
            id: 1,
            name: "Duschkabinen",
            // link: "xxxxxxxxxxxx",
            isActive: false,
            dropMenu: [
              {
                id: 1,
                name: "Eckduschen",
                link:
                  "https://www.ebay.de/str/duschdepot/Duschkabinen/_i.html?_storecat=62595251013",
                isActive: false,
              },
              {
                id: 2,
                name: "Rundduschen",
                link:
                  "https://www.ebay.de/str/duschdepot/Viertelkreis/_i.html?_storecat=64591568013",
                isActive: false,
              },
              {
                id: 3,
                name: "Walk-in Duschen",
                link:
                  "https://www.ebay.de/str/duschdepot/Walk-in/_i.html?_storecat=64591583013",
                isActive: false,
              },
              {
                id: 4,
                name: "Badewannenaufsatz",
                link:
                  "https://www.ebay.de/str/duschdepot/Badewannenaufsatze/_i.html?_storecat=65648068013",
                isActive: false,
              },
              {
                id: 5,
                name: "Falttüren",
                link:
                  "https://www.ebay.de/str/duschdepot/Falttur/_i.html?_storecat=66303295013",
                isActive: false,
              },
              {
                id: 6,
                name: "Schiebetüren",
                link:
                  "https://www.ebay.de/str/duschdepot/Schiebetur/_i.html?_storecat=64489511013",
                isActive: false,
              },
              {
                id: 7,
                name: "Drehtüren",
                link:
                  "https://www.ebay.de/str/duschdepot/Schwingtur-Rahmenlos/_i.html?_storecat=64489513013&LH_BIN=1",
                isActive: false,
              },
              {
                id: 8,
                name: "Scharniertüren",
                link:
                  "https://www.ebay.de/str/duschdepot/Scharniertur/_i.html?_storecat=64591567013&LH_BIN=1",
                isActive: false,
              },
              {
                id: 9,
                name: "Duschtassen",
                link:
                  "https://www.ebay.de/str/duschdepot/Duschwannen/_i.html?_storecat=62595273013&LH_BIN=1",
                isActive: false,
              },
              {
                id: 10,
                name: "Duschrinnen",
                link:
                  "https://www.ebay.de/str/duschdepot/Duschrinne/_i.html?_storecat=68938371013&LH_BIN=1",
                isActive: false,
              },
            ],
          },
          {
            id: 2,
            name: "Badspiegel",
            // link: "xxxxxxxxx",
            isActive: false,
            dropMenu: [
              {
                name: "Badspiegel",
                link:
                  "https://www.ebay.de/str/duschdepot/Badspiegel/_i.html?_storecat=62595271013&LH_BIN=1",
                isActive: false,
              },
              {
                name: "Spiegelschränke",
                link:
                  "https://www.ebay.de/str/duschdepot/Spiegelschrank/_i.html?_storecat=67301270013&LH_BIN=1",
                isActive: false,
              },
            ],
          },
          {
            id: 3,
            name: "Heizkörper",
            // link: "xxxxxxxxx",
            isActive: false,
            dropMenu: [
              {
                name: "Flachheizkörper",
                link:
                  "https://www.ebay.de/str/duschdepot/Flachheizkorp-er/_i.html?_storecat=68717070013&LH_BIN=1",
                isActive: false,
              },
              {
                name: "Röhrenheizkörper",
                link:
                  "https://www.ebay.de/str/duschdepot/Rohrenheizkor-per/_i.html?_storecat=67757225013&LH_BIN=1",
                isActive: false,
              },
              {
                name: "Handtuchheizkörper",
                link:
                  "https://www.ebay.de/str/duschdepot/Handtuchheizk-orper/_i.html?_storecat=70629780013&LH_BIN=1",
                isActive: false,
              },
              {
                name: "Designheizkörper",
                link:
                  "https://www.ebay.de/str/duschdepot/Handtuchheizk-orper/_i.html?_storecat=70629780013&LH_BIN=1",
                isActive: false,
              },
              {
                name: "Heizkörperzubehör",
                link:
                  "https://www.ebay.de/str/duschdepot/Multiblock/_i.html?_storecat=70629702013&LH_BIN=1",
                isActive: false,
              },
            ],
          },
          {
            id: 4,
            name: "Badmöbel",
            // link: "xxxxxxxxx",
            isActive: false,
            dropMenu: [
              {
                name: "Badezimmerschränke",
                link:
                  "https://www.ebay.de/str/duschdepot/Moebel/_i.html?_storecat=70926572013&_sop=12&_dmd=1",
                isActive: false,
              },
              {
                name: "Spiegelschränke",
                link:
                  "https://www.ebay.de/str/duschdepot/Spiegelschrank/_i.html?_storecat=67301270013&LH_BIN=1",
                isActive: false,
              },
            ],
          },
          {
            id: 5,
            name: "Zubehör",
            // link: "xxxxxxxxx",
            isActive: false,
            dropMenu: [
              {
                name: "Duschdichtungen",
                link:
                  "https://www.ebay.de/str/duschdepot/Zubehoren/_i.html?_storecat=62595252013&LH_BIN=1",
                isActive: false,
              },
              {
                name: "Ablaufgarnituren",
                link:
                  "https://www.ebay.de/str/duschdepot/Zubehoren/_i.html?_storecat=62595252013&LH_BIN=1",
                isActive: false,
              },
              {
                name: "Duschtassen",
                link:
                  "https://www.ebay.de/str/duschdepot/Zubehoren/_i.html?_storecat=62595252013&LH_BIN=1",
                isActive: false,
              },
              {
                name: "Duschrinnen",
                link:
                  "https://www.ebay.de/str/duschdepot/Duschrinne/_i.html?_storecat=68938371013",
                isActive: false,
              },
              {
                name: "Heizkörperzubehör",
                link:
                  "https://www.ebay.de/str/duschdepot/Multiblock/_i.html?_storecat=70629702013&LH_BIN=1",
                isActive: false,
              },
            ],
          },
          {
            id: 6,
            name: "Ausverkauf",
            link:
              "https://www.ebay.de/str/duschdepot/Ausverkauf/_i.html?_storecat=72653713013",
            isActive: false,
            // dropMenu: [
            //   {
            //     name: "xxxxxxxxxxxxxx",
            //     link: "xxxxxxxxxxxxxxx",
            //     isActive: false,
            //   },
            // ],
          },
        ],
        search: {
          isShow: true,
          form: {
            className: "form-inline",
            action: "http://www.ebaystores.fr/sunnyshowersfrance",
            placeholder: "SUCHEN...",
          },
        },
      },
      // EE-Nav===========================================
      eeNav: {
        navItems: [
          {
            id: 1,
            name: "home",
            link: "https://www.ebaystores.co.uk/elegantshowers",
            isActive: false,
          },
          {
            id: 2,
            name: "shower room",
            // link: "xxxxxxxxx",
            isActive: false,
            dropMenu: [
              {
                name: "sliding door enclosure",
                link:
                  "https://www.ebaystores.co.uk/Elegantshowers/Sliding-Door-Enclosure-/_i.html?_fsub=36917463011&_sid=1189928441&_trksid=p4634.c0.m322",
                isActive: false,
              },

              {
                name: "corner entry doors",
                link:
                  "https://www.ebaystores.co.uk/Elegantshowers/Corner-Entry-Doors-/_i.html?_fsub=36917464011&_sid=1189928441&_trksid=p4634.c0.m322",
                isActive: false,
              },

              {
                name: "quadrant enclosure",
                link:
                  "https://www.ebaystores.co.uk/Elegantshowers/Quadrant-Enclosure-/_i.html?_fsub=36917465011&_sid=1189928441&_trksid=p4634.c0.m322",
                isActive: false,
              },

              {
                name: "diamond enclosure",
                link:
                  "https://www.ebaystores.co.uk/Elegantshowers/Diamond-Enclosure-/_i.html?_fsub=36917466011&_sid=1189928441&_trksid=p4634.c0.m322",
                isActive: false,
              },

              {
                name: "walk in enclosure",
                link:
                  "https://www.ebaystores.co.uk/Elegantshowers/Walk-in-Enclosure-/_i.html?_fsub=36917467011&_sid=1189928441&_trksid=p4634.c0.m322",
                isActive: false,
              },

              {
                name: "bi-fold enclosure",
                link:
                  "https://www.ebaystores.co.uk/Elegantshowers/Bi-Fold-Enclosure-/_i.html?_fsub=36917468011&_sid=1189928441&_trksid=p4634.c0.m322",
                isActive: false,
              },

              {
                name: "pivot enclosure",
                link:
                  "https://www.ebaystores.co.uk/Elegantshowers/Pivot-Enclosure-/_i.html?_fsub=36917469011&_sid=1189928441&_trksid=p4634.c0.m322",
                isActive: false,
              },

              {
                name: "shower accessories",
                link:
                  "https://www.ebaystores.co.uk/Elegantshowers/Shower-Accessories-/_i.html?_fsub=36917470011&_sid=1189928441&_trksid=p4634.c0.m322",
                isActive: false,
              },

              {
                name: "towel rail",
                link:
                  "https://www.ebaystores.co.uk/Elegantshowers/Towel-Rail-/_i.html?_fsub=36917471011&_sid=1189928441&_trksid=p4634.c0.m322",
                isActive: false,
              },
            ],
          },

          {
            id: 3,
            name: "shower trays",
            // link:"xxxxxxxx",
            isActive: false,
            dropMenu: [
              {
                name: "quadrant",
                link:
                  "https://www.ebaystores.co.uk/Elegantshowers/Quadrant-/_i.html?_fsub=36917531011&_sid=1189928441&_trksid=p4634.c0.m322",
                isActive: false,
              },
              {
                name: "rectangle",
                link:
                  "https://www.ebaystores.co.uk/Elegantshowers/Rectangle-/_i.html?_fsub=36917532011&_sid=1189928441&_trksid=p4634.c0.m322",
                isActive: false,
              },
              {
                name: "square",
                link:
                  "https://www.ebaystores.co.uk/Elegantshowers/Square-/_i.html?_fsub=36917533011&_sid=1189928441&_trksid=p4634.c0.m322",
                isActive: false,
              },
            ],
          },

          {
            id: 4,
            name: "mirrors",
            // link: "xxxxxxxxx",
            isActive: false,
            dropMenu: [
              {
                name: "mirror cabinet",
                link:
                  "https://www.ebaystores.co.uk/Elegantshowers/Mirror-Cabinet-/_i.html?_fsub=36917527011&_sid=1189928441&_trksid=p4634.c0.m322",
                isActive: false,
              },
              {
                name: "mirror",
                link:
                  "https://www.ebaystores.co.uk/Elegantshowers/Mirror-/_i.html?_fsub=36917528011&_sid=1189928441&_trksid=p4634.c0.m322",
                isActive: false,
              },
            ],
          },

          {
            id: 5,
            name: "toilets",
            // link: "xxxxxxxxx",
            isActive: false,
            dropMenu: [
              {
                name: "vanity units",
                link:
                  "https://www.ebaystores.co.uk/Elegantshowers/Vanity-units-/_i.html?_fsub=36917529011&_sid=1189928441&_trksid=p4634.c0.m322",
                isActive: false,
              },
              {
                name: "cabinet",
                link:
                  "https://www.ebaystores.co.uk/Elegantshowers/Cabinet-/_i.html?_fsub=36917530011&_sid=1189928441&_trksid=p4634.c0.m322",
                isActive: false,
              },
            ],
          },

          {
            id: 6,
            name: "home decors",
            // link: "xxxxxxxxxxxxxxxxxxx",
            isActive: false,
            dropMenu: [
              {
                name: "radiators accessories",
                link:
                  "https://www.ebaystores.co.uk/Elegantshowers/Radiators-Accessories-/_i.html?_fsub=36917534011&_sid=1189928441&_trksid=p4634.c0.m322",
                isActive: false,
              },
              {
                name: "three-piece suite",
                link:
                  "https://www.ebaystores.co.uk/Elegantshowers/Three-piece-suite-/_i.html?_fsub=36917535011&_sid=1189928441&_trksid=p4634.c0.m322",
                isActive: false,
              },
              {
                name: "radiator cover",
                link:
                  "https://www.ebaystores.co.uk/Elegantshowers/Radiator-Cover-/_i.html?_fsub=36917536011&_sid=1189928441&_trksid=p4634.c0.m322",
                isActive: false,
              },
              {
                name: "radiators",
                link:
                  "https://www.ebaystores.co.uk/Elegantshowers/Radiators-/_i.html?_fsub=36917537011&_sid=1189928441&_trksid=p4634.c0.m322",
                isActive: false,
              },
              {
                name: "tv stand",
                link:
                  "https://www.ebaystores.co.uk/Elegantshowers/TV-Stand-/_i.html?_fsub=36917538011&_sid=1189928441&_trksid=p4634.c0.m322",
                isActive: false,
              },
              {
                name: "kitchen",
                link:
                  "https://www.ebaystores.co.uk/Elegantshowers/Kitchen-/_i.html?_fsub=36917539011&_sid=1189928441&_trksid=p4634.c0.m322",
                isActive: false,
              },
              {
                name: "bedroom",
                link:
                  "https://www.ebaystores.co.uk/Elegantshowers/Bedroom-/_i.html?_fsub=36917540011&_sid=1189928441&_trksid=p4634.c0.m322",
                isActive: false,
              },
            ],
          },
          {
            id: 7,
            name: "sales",
            // link: "xxxxxxxxxx",
            isActive: false,
            dropMenu: [
              {
                name: "hot sales",
                link:
                  "https://www.ebaystores.co.uk/Elegantshowers/HOT-SALES-/_i.html?_fsub=37181477011&_sid=1189928441&_trksid=p4634.c0.m322",
                isActive: false,
              },
              {
                name: "clearance",
                link:
                  "https://www.ebaystores.co.uk/Elegantshowers/CLEARANCE-/_i.html?_fsub=37181478011&_sid=1189928441&_trksid=p4634.c0.m322",
                isActive: false,
              },
            ],
          },
        ],
        search: {
          isShow: true,
          form: {
            className: "form-inline",
            action: "https://www.ebaystores.co.uk/elegantshowers",
          },
        },
      },
      eeVideo: {
        videoType: [
          {
            id: 1,
            url: require("@/assets/video/EE/BF90-10m.mp4"),
            type: "video/mp4",
          },
          // {
          //   id: 2,
          //   url: require("@/assets/video/EE/BF90-10m.ogg"),
          //   type: "video/ogg",
          // },
          {
            id: 2,
            url: require("@/assets/video/EE/BF90-8m.webm"),
            type: "video/webm",
          },
        ],
        storeLogo: require("@/assets/img/EE/EElogo.png"),
        autoplay: true,
        loop: true,
        muted: true,
      },
      headHeight: 0,
    };
  },
  components: {
    Slide,
    MainNav,
    Video,
  },
  computed: {
    ...mapState("storeInfo", ["storeName"]),
  },
  methods: {
    sendData(data) {
      window.parent.postMessage({ ".store-head": data }, "*");
    },
    setHeadHeight() {
      this.headHeight = this.$refs.headNode.offsetHeight;
      this.sendData(this.headHeight);
    },
    resetIfrH() {
      setTimeout(() => {
        this.setHeadHeight();
      }, 500);
    },
    setIsMob() {
      document.body.offsetWidth < 576
        ? (this.isMob = true)
        : (this.isMob = false);
    },
  },
  mounted() {
    setTimeout(() => {
      this.setHeadHeight();
    }, 500);
    window.onresize = () => {
      this.setHeadHeight();
      this.setIsMob();
    };
  },
  created() {
    this.setIsMob();
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>

<style lang="less" scoped>
.fr-head {
  @media (min-width: 576px) {
    .wh(1366px, auto);
    .mx(auto);
  }
  > div:first-child {
    @media (min-width: 576px) {
      .wh(1170px);
      > a {
        display: inline-block;
      }
    }
    @media (max-width: 576px) {
      .flex-wrap(initial, center, nowrap, column);
      overflow: hidden;
    }
    .mx(auto);
    hr {
      .mf;
    }
  }
  .main-logo {
    .my;
  }
}
.de-s-head {
  @media (min-width: 576px) {
    .wh(1400px, auto);
    .mx(auto);
  }
  .logoImg-wrap {
    display: block;
    background-color: @neutralColor;
    @media (max-width: 576px) {
      // text-align: center;
      .pl;
      // .py(0.5em);
    }
  }
  .main-logo {
    .my(1.4em);
    @media (min-width: 576px) {
      .ml(110px);
    }
  }
}
</style>
